import NavIcons from "../nav-icons/NavIcons";
import { AuthRoutes, USERTYPES, resolveBackendForHost } from "../../../constants/Constants";
import React from "react";
import { t } from "i18next";
import { getEnv } from '../../../helpers/EnvHelper';

export const customNavbarTooltipStyles = {
  root: {
    backgroundColor: 'gray',
  },
};

export const navBarItems= (currentPath,roles,hoveredItem, isActiveData, enableLlmReport, qcOutsourceLogin, routeToNodeEnabled, aiRouteToNodeEnabled)=>{
  let enterprise = (getEnv("REACT_APP_ENTERPRISE_PLATFORM")=="true"||getEnv("REACT_APP_ENTERPRISE_PLATFORM")==true)?true:false;
  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;
  let showMaster = (roles[0] == USERTYPES.ADMIN && !enterprise);
  let showOptios = {
    reportTemplate : roles[0] == USERTYPES.FIRMADMIN?true:false
  }
  let showProfile = roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || (roles.includes(USERTYPES.FIRMTECHNICIAN,USERTYPES.FIRMDOCTOR,USERTYPES.FIRMADMIN)
  && !enterprise) || (roles[0] == USERTYPES.RADIOLOGIST && !enterprise) 
|| (roles.includes(USERTYPES.FIRMTECHNICIAN,USERTYPES.FIRMDOCTOR) && enterprise);
// console.log("--- HoveredItem ---",hoveredItem);
hoveredItem = hoveredItem == null ? "": hoveredItem;

var showReport = roles[0] == USERTYPES.FIRMADMIN?true:false;
 
const hideBranding = resolveBackendForHost(window.location.host).matched === true;
const helpChildrenVisible =
  (!enterprise &&
    (
      (roles[0] === USERTYPES.RADIOLOGIST || roles[0] === USERTYPES.SUPERVISOR) || // MS Word
      (!hideBranding) // FAQ or Support
    ));


return [
        {
          id:"study-list",
          title: t("navbar.study-list"),
          icon: <NavIcons iconName="studylist" active={currentPath==AuthRoutes.STUDYLIST?true:false}/>,
          path: AuthRoutes.STUDYLIST,
          show: true,
          active: true,
          mobileBottomBar: true
        },
        {
          id:"analytics",
          title: t("navbar.analytics"),
          icon:  <NavIcons iconName="analytics" active={currentPath==AuthRoutes.ANALYTICS?true:false}/>,
          path: AuthRoutes.ANALYTICS,
          show: roles[0] != USERTYPES.TYPIST && !qcOutsourceLogin,
         // show: !(roles[0] === USERTYPES.TYPIST || roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMTECHNICIAN), 
          active: true,
          mobileBottomBar: true
        },
        {
          id:"billing",
          title: t("navbar.billing"),
          icon: <NavIcons iconName="billing" active={false}/>,
          path: "https://augmento-o.deeptek.ai/",
          show: (getEnv("REACT_APP_SHOW_BILLING") == "true" && (roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.RADIOLOGIST) && !hideBranding),
          active: true,
          newTab:true,
          redirect:true
        },
        // {
        //   id:"billing",
        //   title: t("navbar.billing"),
        //   icon: <NavIcons iconName="billing" active={false} />,
        //   path: AuthRoutes.BILLING,
        //   show: roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.ADMIN,
        //   active: true
        // },
        {
          id:"logs",
          title: t("navbar.logs"),
          icon: "",
          path: "",
          show:  (roles[0] == USERTYPES.ADMIN && !enterprise) || (roles[0] == USERTYPES.FIRMADMIN && enterprise),
          active: false,
          conntectId:[],
          dropped: true
        },
        {
          id:"audit-logs",
          title: t("navbar.issues-and-troubleshooting"),
          icon: <NavIcons iconName="troubleshooting" active={currentPath==AuthRoutes.ISSUESANDTROUBLESHOOTING?true:false} />,
          path: AuthRoutes.ISSUESANDTROUBLESHOOTING,
          show:  (roles[0] == USERTYPES.ADMIN && !enterprise) || (roles[0] == USERTYPES.FIRMADMIN && enterprise),
          active: true,
        },
        {
          id:"pacs-queue-page",
          title: t("navbar.pacs-queue"),
          icon: <NavIcons iconName="pacs-queue" active={currentPath==AuthRoutes.PACSQUEUELIST?true:false}/>,
          path: AuthRoutes.PACSQUEUELIST,
          show: routeToNodeEnabled && (roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.RADIOLOGIST),
          active: true,
        },
        {
          id:"ai-request-page",
          title: t("navbar.ai-request"),
          icon: <NavIcons iconName="ai-requests" active={currentPath==AuthRoutes.AIREQUESTLIST?true:false}/>,
          path: AuthRoutes.AIREQUESTLIST,
          show: aiRouteToNodeEnabled && (roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.ADMIN),
          active: true,
        },
        {
          id:"firm2firm-dashboard-page",
          title: t("navbar.firm2firm-dashboard"),
          icon: <NavIcons iconName="firm2firm" active={currentPath==AuthRoutes.FIRM2FIRM_DASHBOARD?true:false}/>,
          path: AuthRoutes.FIRM2FIRM_DASHBOARD,
          show: (roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMTECHNICIAN || roles[0] === USERTYPES.FIRMDOCTOR),
          active: true,
        },
        {
          id:"adv-viewer-license",
          title: t("navbar.adv-license"),
          icon: <NavIcons iconName="adv-license" active={currentPath==AuthRoutes.ADVLICENSE?true:false}/>,
          path: AuthRoutes.ADVLICENSE,
          show: (roles[0] === USERTYPES.ADMIN),
          active: true,
        },
        {
          id:"profile",
          title: t("navbar.profile"),
          icon: "",
          path: "",
          show:  showProfile,
          active: false,
          conntectId:[],
          dropped: true
        },
        {
          id:"firms",
          title: !enterprise?t("navbar.firms"):t("navbar.hospitals"),
          icon:  <NavIcons iconName="firms" active={currentPath==AuthRoutes.FIRMLIST || (roles[0] === USERTYPES.ADMIN && currentPath === AuthRoutes.FIRMDETAILS)?true:false}/>,
          path: AuthRoutes.FIRMLIST,
          show:  roles[0] == USERTYPES.ADMIN,
          active: true,
        },
        // NOTE: Projects link hidden from PROFILE menu (super admin) per request. Uncomment to restore.
        // {
        //   id:"projects",
        //   title: t("navbar.projects"),
        //   icon:  <NavIcons iconName="projects"  active={currentPath==AuthRoutes.PROJECTLIST || (roles[0] === USERTYPES.ADMIN && currentPath === AuthRoutes.PROJECTDETAILS)?true:false}/>,
        //   path: AuthRoutes.PROJECTLIST,
        //   show:  roles[0] == USERTYPES.ADMIN,
        //   active: true,
        // },
        {
          id:"clients",
          title: !enterprise?t("navbar.clients"):t("navbar.hospitals"),
          icon:  <NavIcons iconName="clients" active={currentPath==AuthRoutes.CLIENTLIST?true:false}/>,
          path: AuthRoutes.CLIENTLIST,
          show:  (roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMTECHNICIAN),
          active: true,
        },
        {
          id:"clients",
          title: t("navbar.clients"),
          icon:  <NavIcons iconName="clients" active={currentPath==AuthRoutes.CLIENTLIST?true:false}/>,
          path: AuthRoutes.CLIENTLIST,
          show:  (roles[0] == USERTYPES.RADIOLOGIST  && !enterprise),
          active: true,
        },
        {
          id:"providers",
          title: !enterprise?t("navbar.providers"):t("navbar.radiologists"),
          icon:  <NavIcons iconName="providers" active={currentPath==AuthRoutes.RADIOLOGISTLIST?true:false}/>,
          path: AuthRoutes.RADIOLOGISTLIST,
          show:  roles[0] == USERTYPES.FIRMADMIN,
          active: true,
        },
        {
          id:"firm",
          title:t("navbar.firm"),
          icon:  <NavIcons iconName="firms" active={currentPath==AuthRoutes.FIRMDETAILS?true:false}/>,
          path: AuthRoutes.FIRMDETAILS,
          show:  (roles[0] == USERTYPES.FIRMADMIN)
                && !enterprise,
          active: true,
        },
        {
          id:"hospital",
          title: t("navbar.hospital"),
          icon:  <NavIcons iconName="clients" active={currentPath==AuthRoutes.FIRMDETAILS?true:false}/>,
          path: AuthRoutes.FIRMDETAILS,
          show:  (roles[0] == USERTYPES.FIRMTECHNICIAN || roles[0] == USERTYPES.FIRMDOCTOR) && enterprise,
          active: true,
        },
        {
          id:"providers",
          title: (!enterprise && roles[0] !== USERTYPES.ADMIN)?t("navbar.providers"):t("navbar.radiologists"),
          icon:  <NavIcons iconName="providers" active={currentPath==AuthRoutes.ADMINRADIOLOGISTLIST?true:false}/>,
          path: AuthRoutes.ADMINRADIOLOGISTLIST,
          show:  roles[0] == USERTYPES.ADMIN,
          active: true,
        },
        {
          id:"hanging-protocol",
          title: t("navbar.hanging-protocol"),
          icon: <NavIcons iconName="hanging-protocol" active={currentPath==AuthRoutes.HANGINGPROTOCOLLIST?true:false}/>,
          path: AuthRoutes.HANGINGPROTOCOLLIST,
          show: (showMaster  || roles[0] == USERTYPES.RADIOLOGIST),
          active: true,
        },
        {
          id:"master",
          title: t("navbar.master"),
          icon: "",
          path: "",
          show:  (showMaster  || roles[0] == USERTYPES.FIRMADMIN),
          active: false,
          conntectId:[],
          dropped: true
        },
        {
          id:"admin-user",
          title: t("navbar.admin-user"),
          icon: <NavIcons iconName="admin-user" active={currentPath==AuthRoutes.ADMINUSERLIST?true:false}/>,
          path: AuthRoutes.ADMINUSERLIST,
          show:  (showMaster && !enterprise),
          active: true,
        },
        {
          id:"findings",
          title: t("navbar.findings"),
          icon: <NavIcons iconName="finding" active={currentPath==AuthRoutes.ANNOTATION?true:false}/>,
          path: AuthRoutes.ANNOTATION,
          show:  showMaster,
          active: true,
  },
        {
          id:"modality",
          title: t("navbar.modalities"),
          icon: <NavIcons iconName="modality" active={currentPath==AuthRoutes.MODALITY?true:false}/>,
          path: AuthRoutes.MODALITY,
          show:  showMaster,
          active: true,
  },
        {
          id:"sub-modality",
          title: t("navbar.sub-modalities"),
          icon: <NavIcons iconName="sub-modality" active={currentPath==AuthRoutes.SUBMODALITY?true:false}/>,
          path: AuthRoutes.SUBMODALITY,
          show: showMaster && getEnv("REACT_APP_VDC_PLATFORM") === "true",
          active: true,
        },
        {
          id:"report-templates",
          title: t("report-templates.report-templates"),
          icon: <NavIcons iconName="report-template" active={currentPath==AuthRoutes.REPORTTEMPLATES?true:false}/>,
          path: AuthRoutes.REPORT_TEMPLATE,
          show:  (showMaster || (getEnv("REACT_APP_VDC_PLATFORM")=="false" && roles[0] == USERTYPES.RADIOLOGIST) || (roles[0] === USERTYPES.SUPERVISOR && !qcOutsourceLogin) || roles[0] == USERTYPES.FIRMADMIN),
          active: true,
        },
        {
          id:"my-styles",
          title: t("navbar.agentic-style"),
          icon: <NavIcons iconName="my-styles" active={currentPath==AuthRoutes.MY_STYLES?true:false}/>,
          path: AuthRoutes.MY_STYLES,
          show: (enableLlmReport && roles[0] == USERTYPES.RADIOLOGIST),
          active: true,
        },
        {
          id:"agentic-templates",
          title: t("navbar.agentic-template"),
          icon: <NavIcons iconName="my-styles" active={currentPath==AuthRoutes.AGENTIC_TEMPLATE?true:false}/>,
          path: AuthRoutes.AGENTIC_TEMPLATE,
          show: (roles[0] == USERTYPES.FIRMADMIN),
          active: true,
        },
        {
          id:"ai-node-config",
          title: t("navbar.ai-node-config"),
          icon: <NavIcons iconName="ai-file" active={currentPath==AuthRoutes.AI_NODE_CONFIG?true:false}/>,
          path: AuthRoutes.AI_NODE_CONFIG,
          show: (aiRouteToNodeEnabled && roles[0] == USERTYPES.FIRMADMIN),
          active: true,
        },
        {
          id:"external-firm-config",
          title: t("navbar.external-firm-config"),
          icon: <NavIcons iconName="external-firm-connection" active={currentPath==AuthRoutes.EXTERNAL_FIRM_CONFIG?true:false}/>,
          path: AuthRoutes.EXTERNAL_FIRM_CONFIG,
          show: (roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR),
          active: true,
        },
        {
          id:"return-reason-category-management",
          title: t("navbar.return-reason-category-management"),
          icon: <NavIcons iconName="ai-file" active={currentPath==AuthRoutes.RETURN_REASON_CATEGORY_MANAGEMENT?true:false}/>,
          path: AuthRoutes.RETURN_REASON_CATEGORY_MANAGEMENT,
          show: (roles[0] == USERTYPES.ADMIN),
          active: true,
        },
        {
          id:"report-header-templates",
          title: t("heading.report-header-templates"),
          icon: <NavIcons iconName="header-template" active={currentPath==AuthRoutes.HEADERTEMPLATE?true:false}/>,
          path: AuthRoutes.HEADERTEMPLATE,
          show:  showMaster,
          active: true,
        },
        {
          id:"user",
          title: t("navbar.users").toUpperCase(),
          icon: "",
          path: "",
          show:  roles[0] == USERTYPES.FIRMADMIN,
          active: false,
          conntectId:[],
          dropped: true
        },
        {
          id:"supervisor",
          title: t("navbar.supervisor"),
          icon: <NavIcons iconName="supervisor" active={currentPath==AuthRoutes.SUPERVISORLIST?true:false}/>,
          path: AuthRoutes.SUPERVISORLIST,
          show:  roles[0] == USERTYPES.FIRMADMIN,
          active: true,
        },
        {
          id:"firm-technicians",
          title: t("navbar.firm-technicians"),
          icon: <NavIcons iconName="firm-technician" active={currentPath==AuthRoutes.FIRMTECHNICIANLIST?true:false}/>,
          path: AuthRoutes.FIRMTECHNICIANLIST,
          show:  roles[0] == USERTYPES.FIRMADMIN && !enterprise,
          active: true,
        },
        {
          id:"firm-doctors",
          title: t("navbar.firm-doctors"),
          icon: <NavIcons iconName="firm-doctor" active={currentPath==AuthRoutes.FIRMDOCTORLIST?true:false}/>,
          path: AuthRoutes.FIRMDOCTORLIST,
          show:  roles[0] == USERTYPES.FIRMADMIN && !enterprise,
          active: true,
        },
        {
          id:"firm-admins",
          title: t("navbar.firm-admins"),
          icon: <NavIcons iconName="admin-user" active={currentPath==AuthRoutes.FIRMADMINUSERLIST?true:false}/>,
          path: AuthRoutes.FIRMADMINUSERLIST,
          show:  roles[0] == USERTYPES.FIRMADMIN,
          active: true,
        },
        {
          id:"typist",
          title: t("navbar.typist"),
          icon: <NavIcons iconName="admin-user" active={currentPath==AuthRoutes.TYPISTUSERLIST?true:false}/>,
          path: AuthRoutes.TYPISTUSERLIST,
          show:  roles[0] == USERTYPES.FIRMADMIN,
          active: true,
        },
        {
          id:"help",
          title: t("navbar.help"),
          icon: "",
          path: "",
          //show: !enterprise,
          show: helpChildrenVisible,
          active: false,
          conntectId:[],
          dropped: true
        },
        {
          id:"ms-word-in",
          title: t("navbar.ms-word-in"),
          icon: <NavIcons iconName="ms-word" active={false} />,
          path: "https://drive.google.com/file/d/1GezfDhJhT2agVgTbFnT1eqVNUt2Eli2A/view?usp=sharing",
          show: !enterprise && (roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.SUPERVISOR),
          active: true,
          newTab:true
        },
        // {
        //   id:"tutorial-video",
        //   title: t("navbar.tutorial-video"),
        //   icon: <NavIcons iconName="tutorial-video" active={false}/>,
        //   path: "https://youtu.be/BNHN5Q6zDmY",
        //   show: !enterprise,
        //   active: true,
        //   newTab:true
        // },
        {
          id:"faq",
          title: t("navbar.faq"),
          icon: <NavIcons iconName="faq" active={false}/>,
          path: "https://drive.google.com/file/d/1R5YrQcBlTHg9CZ5tNrQVATz0fPm9151x/view",
          show: !enterprise && !hideBranding,
          active: true,
          newTab:true
        },
        {
          id:"support",
          title: t("navbar.support"),
          icon: <NavIcons iconName="support" active={false}/>,
          path: "mailto:support@deeptek.ai",
          show: !enterprise && !hideBranding,
          active: true,
          newTab:true
        }
    ]};
